import { FC } from 'react'
import UserInfo from '../userinfo/UserInfo'
import { topBarStyle } from './TopBar.style'
import { DataTheme } from 'src/Enums'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from 'src/Store'
import { getDataThemeName } from 'src/utils/Utils'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faIcicles, faCloudSunRain, faLeaf, faBolt } from '@fortawesome/free-solid-svg-icons'
import { IconButton, Tooltip } from '@material-ui/core'
import HelpOutlineIcon from '@material-ui/icons/HelpOutline'
import { sidebarAnimationDuration, tooltipDelay } from 'src/Constants'
import { useIntl } from 'react-intl'
import { wikiActions } from 'src/actions/WikiActions'
import { SearchField } from '../searchfield/SearchField'
import { WikiView } from 'src/reducers/WikiReducer'

export interface TopBarProps {} // eslint-disable-line @typescript-eslint/no-empty-interface

const defaultProps: TopBarProps = {
}

export const TopBar: FC<TopBarProps> = (props: TopBarProps) => {
  const classes = topBarStyle()
  const dispatch = useDispatch()
  const intl = useIntl()

  const dataTheme = useSelector((state: RootState): DataTheme => state.generalState.dataTheme)
  const currentWikiViews = useSelector((state: RootState): WikiView[] => state.wikiState.currentWikiViews)
  const showWikiSideBar = useSelector((state: RootState): boolean => state.wikiState.showWikiSideBar)

  /**
   * When toggle button is clicked the WikiSideBar is toggled.
   */
  const toggleWikiSideBarClicked = (): void => {
    if (showWikiSideBar) {
      if (currentWikiViews.includes(WikiView.WikiBrowser)) {
        dispatch(wikiActions.showWikiSideBar(false))
        setTimeout(function () {
          dispatch(wikiActions.clearViews())
        }, sidebarAnimationDuration * 1.5)
      } else {
        dispatch(wikiActions.clearViewStack())
        dispatch(wikiActions.pushView(WikiView.WikiBrowser))
      }
    } else {
      dispatch(wikiActions.pushView(WikiView.WikiBrowser))
      dispatch(wikiActions.showWikiSideBar(true))
    }
    dispatch(wikiActions.clearDocument())
  }

  return (
    <div className={classes.root}>
      <div className={classes.logo}>
        <a href='https://www.geo.dk' target='_blank' rel='noreferrer noopener'>
          <img
            src='logo.png'
            alt='Geo logo'
            className={classes.image}
          />
        </a>
        {dataTheme === DataTheme.ICE_AGE && (<FontAwesomeIcon icon={faIcicles} title={getDataThemeName(dataTheme)} className={classes.themeImage} />)}
        {dataTheme === DataTheme.ENVIRONMENT && (<FontAwesomeIcon icon={faLeaf} title={getDataThemeName(dataTheme)} className={classes.themeImage} />)}
        {dataTheme === DataTheme.CLIMATE && (<FontAwesomeIcon icon={faCloudSunRain} title={getDataThemeName(dataTheme)} className={classes.themeImage} />)}
        {dataTheme === DataTheme.ENERGY && (<FontAwesomeIcon icon={faBolt} title={getDataThemeName(dataTheme)} className={classes.themeImage} />)}
      </div>
      <div className={classes.searchField}>
        <SearchField />
      </div>
      <div className={classes.buttons}>
        <div className={classes.wikiButton}>
          <Tooltip
            title={intl.formatMessage({ id: 'wiki.button.general' })}
            enterDelay={tooltipDelay}
            placement='right'
          >
            <IconButton size='medium' className={classes.wikiIcon} onClick={toggleWikiSideBarClicked}>
              <HelpOutlineIcon />
            </IconButton>
          </Tooltip>
        </div>
        <div className={classes.userInfo}>
          <UserInfo />
        </div>
      </div>
    </div>
  )
}

TopBar.defaultProps = defaultProps

export default TopBar
